import React, { Component } from 'react';
//import './breadcrumb.css';

export class Breadcrumb extends Component {
    static displayName = Breadcrumb.name;

    constructor(props) {
        super(props);
        this.state = {
            breadcrumbData: []
        }
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        var breadcrumbData = this.state.breadcrumbData;

        return (
            <nav className="breadcrumb-wrap" aria-label="Breadcrumb">
                <div className="breadcrumb">
                    {breadcrumbData.map((crumb, index) => {
                        let isCurrent = index === breadcrumbData.length - 1;
                        return crumb.allowNavigation && !isCurrent ?
                            <a href={crumb.link} key={index}>{crumb.name}</a> :
                            <span key={index} aria-current={isCurrent ? 'page' : undefined}>{crumb.name}</span>
                    })}
                </div>
            </nav>
        );
    }

    async getComponentData() {
        var url = window.location.href.split('/').slice(3);
        var breadcrumbData = [];
        
        if (url[0] != "PagePreview" && url[0].toLowerCase() != "event" && url[0].toLowerCase() != "blog" && url[0] != "PreviewBlog") {
            for (var i = 0; i < url.length; i++) {
                var link = url.slice(0, i + 1).join('/');
                if (link != "") {
                    const response = await fetch('Components/GetPageFromUrl?pageUrl=' + link, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        }
                    });

                    if (response.status == 200) {
                        const page = await response.json();

                        if (page != null) {
                            breadcrumbData.push({ name: page.name.toUpperCase(), link: link, allowNavigation: page.allowNavigation });
                        }
                    }
                    else { //Add parameters to url
                        let lastPage = breadcrumbData.pop();
                        breadcrumbData.push({ name: lastPage.name.toUpperCase(), link: link, allowNavigation: lastPage.allowNavigation });
                    }
                }
            }
        }
        
        this.setState({
            breadcrumbData: breadcrumbData
        });
    }
}

export default Breadcrumb;
